module.exports = __webpack_public_path__ + "img/icon-robot.0ba82225.svg";